import PropTypes from 'prop-types';
import ArticleActions from '../../articleActions/articleActions';
import ViewAtPublisherAnchor from '../../articleActions/actionTypes/viewAtPublisherAnchor';
import { DoiArticleEventsPropTypes } from '../../../utils/trackers/createArticleEvents';

export default function DoiReferencePreviewActions({ doi, viewAtPublisherEventData }) {
  return (
    <ArticleActions>
      <ViewAtPublisherAnchor
        id={`doi-reference-preview-${encodeURIComponent(doi)}`}
        doi={doi}
        viewAtPublisherEventData={viewAtPublisherEventData}
      />
    </ArticleActions>
  );
}

DoiReferencePreviewActions.propTypes = {
  doi: PropTypes.string.isRequired,
  viewAtPublisherEventData: DoiArticleEventsPropTypes.viewAtPublisher,
};

DoiReferencePreviewActions.defaultProps = {
  viewAtPublisherEventData: undefined,
};
